import React from 'react';
import _ from 'underscore';

import { DEFAULT_PROFILE_FILL_COLOR, DEFAULT_PROFILE_TEXT_COLOR, INVERTED_PROFILE_FILL_COLOR, INVERTED_PROFILE_TEXT_COLOR, ProfilePicture } from '../../common/react/components/ProfilePicture';
import { Helpers } from '../../ts/helpers/Helpers';

export function UserProfilePicture(props: UserProfilePicture.Props): JSX.Element {

  const imageSize = props.imageSize;
  const defaultDivStyle = {
    height: imageSize,
    width: imageSize
  };

  const textColor = props.useInvertedColors ? INVERTED_PROFILE_TEXT_COLOR : DEFAULT_PROFILE_TEXT_COLOR;
  const fillColor = props.useInvertedColors ? INVERTED_PROFILE_FILL_COLOR : DEFAULT_PROFILE_FILL_COLOR;

  return (
    <div style={_.extend(defaultDivStyle, props.divStyle)}>
      <ProfilePicture
        contentLetters={Helpers.generateAbbrevFromName(props.profileDisplayName)}
        imageUrl={props.imageUrl}
        shape={ProfilePicture.Shape.Circle}
        sizeInPixels={props.imageSize}
        fontSizeInPixels={props.fontSize}
        testId={props.testId}
        textColor={textColor}
        fillColor={fillColor}
      />
    </div>
  );
}

export module UserProfilePicture {

  export interface Props {
    profileDisplayName: string;
    imageUrl: string;
    imageSize: number;
    fontSize: number;
    divStyle?: React.CSSProperties;
    testId?: string;
    useInvertedColors?: boolean;
  }

}
